/* global window */
import axios from 'axios'
import qs from 'qs'
import jsonp from 'jsonp'
import lodash from 'lodash'
import pathToRegexp from 'path-to-regexp'
import {message} from 'antd'
import {YQL, CORS} from './config'
import promiseFinally from 'promise.prototype.finally'
import {browserHistory} from "react-router";
import {clearAuth} from "../services/global";

promiseFinally.shim();


export const setInterceptors = (store) => {


    axios.interceptors.request.use(function (config) {
        if (localStorage.getItem('token')) {
            config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
        }
        return config;
    }, function (err) {
        return Promise.reject(err);
    });

    axios.interceptors.response.use(function (response) {
        const data = response.data
        if (data && data.code == 401) {
            // console.log(browserHistory.getCurrentLocation().pathname.split('/')[1])
            if(browserHistory.getCurrentLocation().pathname.split('/')[1] == "mobile"){
                localStorage.removeItem('token')
                return response;
            }
            if (browserHistory.getCurrentLocation().pathname != "/login") {
                const err = new Error(data.msg)
                err.data = data;
                err.response = response;
                err.code = 401;
                clearAuth(true, true);
                throw err
            }

        }
        if(data && data.bizCode == 403002){ //子账号
            browserHistory.push("/subaccount-checkinpoints")
        }
        return response;
    }, function (error) {
        // Do something with response error
        if (error.response.status === 401) {
            clearAuth(true, true);
        }
        return Promise.reject(error);
    });


};


const fetch = (options) => {
    let {
        method = 'get',
        data,
        fetchType,
        url,
    } = options

    var cloneData = lodash.cloneDeep(data)

    try {
        let domin = ''
        if (url.match(/[a-zA-z]+:\/\/[^/]*/)) {
            domin = url.match(/[a-zA-z]+:\/\/[^/]*/)[0]
            url = url.slice(domin.length)
        }
        const match = pathToRegexp.parse(url)
        url = pathToRegexp.compile(url)(data)
        for (let item of match) {
            if (item instanceof Object && item.name in cloneData) {
                delete cloneData[item.name]
            }
        }
        url = domin + url;

        cloneData = (cloneData && "__self__" in cloneData) ? cloneData["__self__"] : cloneData;

    } catch (e) {
        message.error(e.message)
    }

    if (fetchType === 'JSONP') {
        return new Promise((resolve, reject) => {
            jsonp(url, {
                param: `${qs.stringify(data)}&callback`,
                name: `jsonp_${new Date().getTime()}`,
                timeout: 4000,
            }, (error, result) => {
                if (error) {
                    reject(error)
                }
                resolve({statusText: 'OK', status: 200, data: result})
            })
        })
    } else if (fetchType === 'YQL') {
        url = `http://query.yahooapis.com/v1/public/yql?q=select * from json where url='${options.url}?${encodeURIComponent(qs.stringify(options.data))}'&format=json`
        data = null
    }

    switch (method.toLowerCase()) {
        case 'get':
            return axios.get(url, {
                params: cloneData,
            })
        case 'delete':
            return axios.delete(url, {
                data: cloneData,
            })
        case 'post':
            return axios.post(url, cloneData)
        case 'put':
            return axios.put(url, cloneData)
        case 'patch':
            return axios.patch(url, cloneData)
        default:
            return axios(options)
    }
}

export default function request(options) {
    if (options.url && options.url.indexOf('//') > -1) {
        const origin = `${options.url.split('//')[0]}//${options.url.split('//')[1].split('/')[0]}`
        if (window.location.origin !== origin) {
            if (CORS && CORS.indexOf(origin) > -1) {
                options.fetchType = 'CORS'
            } else if (YQL && YQL.indexOf(origin) > -1) {
                options.fetchType = 'YQL'
            } else {
                options.fetchType = 'JSONP'
            }
        }
    }

    return fetch(options).then((response) => {
        const {statusText, status} = response
        let data = options.fetchType === 'YQL' ? response.data.query.results.json : response.data
        if (data instanceof Array) {
            data = {
                list: data,
            }
        }
        return Promise.resolve({
            _success: true,
            _message: statusText,
            _statusCode: status,
            ...data,
        })
    }).catch((error) => {
        const {response} = error
        let msg
        let statusCode
        if (response && response instanceof Object) {
            const {data, statusText} = response
            statusCode = response.status
            msg = data.message || statusText
        } else {
            statusCode = 600
            msg = error.message || 'Network Error'
        }
        return Promise.reject({_success: false, _statusCode: statusCode, _message: msg})
    })
}



// WEBPACK FOOTER //
// ./src/utils/request.js